/** Registers the production service worker (cache-first, 6-hour TTL). */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) {
    return;
  }

  const buildId =
    typeof __APP_BUILD_ID__ !== 'undefined' ? __APP_BUILD_ID__ : '1';

  void navigator.serviceWorker
    .register(`/sw.js?build=${encodeURIComponent(buildId)}`, { scope: '/' })
    .catch((err) => {
      console.warn('Service worker registration failed:', err);
    });
}
